import { styled } from "styled-components";

// 프로필 이미지
export const ProfileImage = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 100%;
  border: 2px solid black;
`;
